import $ from 'jquery'
import { fileTypeToIconPath } from 'util/icons'
import _ from 'underscore'
// eslint-disable-next-line import/no-unresolved
import { findPhoneNumbersInText } from 'libphonenumber-js'
const Mustache = require("mustache");

import { ajax } from 'util/ajax'
import { nullifyBlankObject } from "util/core"

import { isStaff, isTeam } from 'app/helpers/account_helpers';

import {
    betterFormatDate,
    isToday,
} from "util/date"

import { localize, Strings } from 'util/localize'

import {
    chomp,
    escapeHTML,
} from 'util/string'

import { renderTemplate, styleContent } from 'util/template_renderer'

import helpPopoverTemplate from 'common/help_popover'
import validationErrorTemplate from 'common/validation_error'
import linkifyHtml from "linkifyjs/lib/linkify-html";

    var i;

    // Takes in an element and sets its contents to a checkmark (Unicode 2713)
    // and gives it a tooltip indicating that its accompanying field contains
    // valid input.
    export function markElementValidationStatus(elt, valid, titleOverride) {
        if (!elt) {
            return;
        }

        if (valid) {
            elt
            .text("\u2713")
            .attr('title', 'Valid information entered')
            .removeClass("invalid")
            .addClass("valid");
        } else {
            elt
            .text("\u00D7")
            .attr('title', titleOverride || 'Please enter valid information')
            .removeClass("valid")
            .addClass("invalid");
        }
    }

    export function showElementValidationErrorMessage(elt, message) {
        if (!elt || elt.next().is('.validation_error')) {
            return;
        }
        elt.after(renderTemplate(validationErrorTemplate, {message:message}))
    }

    export function removeElementValidationErrorMessage(elt) {
        if (!elt) {
            return;
        } else if (elt.next().is('.validation_error')) {
            elt.next().remove()
        }
    }

    // `execution` is expected to be a plain JavaScript object that has the properties
    // `complete_count` and `total_count`. If it is missing either property, or either
    // property is null, or if `total_count` is `0`, then this returns `0`.
    //
    // Otherwise it returns a value between 0 and 100: `complete_count / total_count`.
    export function workflowExecutionProgressPercentage(execution) {
        let complete = parseInt(execution.complete_count || 0, 10);
        let total = parseInt(execution.total_count || 0, 10);

        if (complete == 0 || total == 0) {
            return 0;
        } else {
            return 100.0 * (complete / total);
        }
    }

    function _accountHasProfilePicture(model) {
        if (!model) {
            return false;
        }

        if (model.photo === "0" || model.photo === 0) {
            return false;
        }

        if (nullifyBlankObject(model.photo) === null) {
            return false;
        }

        if (nullifyBlankObject(model.username) === null) {
            return false;
        }

        return true;
    }

    // Given a JS object that resembles a Contact (the `model`),
    // figure out what the `model`'s avatar should be and return
    // an object literal with the neccessary data elements needed
    // to render it (the avatar)
    export function extractContactAvatar(model) {
        if (!model) {
            return {}
        }
        // If the model happens to be a Backbone Model,
        // then convert it to a workable format.
        if (typeof model.cid !== "undefined") {
            model = model.toJSON();
        }

        return {
            exists: _accountHasProfilePicture(model),
            seqnum: nullifyBlankObject(model.photo),
            username: nullifyBlankObject(model.username),
            formalname: nullifyBlankObject(model.formalname),
            initials: abbreviationForAccount(model),
            supportUser: model.username === "support"
        };
    }

    // Given a JS object that resembles a Conversation (the `model`),
    // figure out what the `model`'s avatars should be and poke those
    // values into the `model` object.
    export function populateConversationAvatars(model) {
        var allAccounts = accountsFromConversation(model);
        var participantCount = allAccounts.length;
        var accounts = _.filter(allAccounts, function(elt) {
            return App.account.get("username") !== elt.username;
        });

        var account = null;
        var tinyAccount = null;
        var tinyAvatarText = null;

        if (participantCount <= 1) {
            // just a single account in the conversation... weird but OK (probably the current user)
            account = allAccounts[0];
        } else if (participantCount < 3) {
            // 2 people: just show the other person's avatar.
            account = accounts[0];
        } else if (participantCount === 3) {
            // 3 people: show most recent person's avatar BIG and other person's small
            account = accounts[0];
            tinyAccount = accounts[1];
            tinyAvatarText = abbreviationForAccount(accounts[1]);
        }
        else {
            // 4+ people in convo: show most recent person's avatar BIG and total of others in convo in small bubble (look at bottom highlighted example ^^)
            account = accounts[0];
            tinyAvatarText = "+" + (accounts.length - 1);
        }

        model.avatar = extractContactAvatar(account);

        if (tinyAccount || tinyAvatarText) {
            model.tinyAvatar = {
                exists: _accountHasProfilePicture(tinyAccount),
                initials: tinyAvatarText
            };

            if (model.tinyAvatar.exists) {
                model.tinyAvatar.seqnum = nullifyBlankObject(account.photo);
                model.tinyAvatar.username = nullifyBlankObject(account.username);
            }
        }
    }

    function _accountHasNoName(account) {
        return nullifyBlankObject(account.formalname) === null &&
                nullifyBlankObject(account.shortname) === null &&
                nullifyBlankObject(account.firstname) === null &&
                nullifyBlankObject(account.lastname) === null;
    }

    // Initials from the specified account
    // For user accounts, this will be first and last names. e.g. "John", "Doe" => "JD".
    // For roles, this will be one character: "UWMC Nursing" => "U".
    export function abbreviationForAccount(account) {
        var letters = "";

        if (_accountHasNoName(account)) {
            return "";
        }

        if (isTeam(account) || isStaff(account)) {
            if (account.formalname.length > 0) {
                letters += account.formalname[0];
            }
            else if (account.shortname.length > 0) {
                letters += account.formalname[0];
            }
        }
        else {
            if (account.firstname && account.firstname.length > 0) {
                letters += account.firstname[0];
            }

            if (account.lastname && account.lastname.length > 0) {
                letters += account.lastname[0];
            }

            if (!letters && account.formalname && account.formalname.length > 0) {
                letters += account.formalname[0];
            }
        }

        return letters.toUpperCase();
    }

    // given a participant string (e.g. "bob*,joe,sue"), and a hash of user accounts,
    // return an object with 'targets' and 'others' arrays of user accounts, if accounts are passed
    // otherwise 'targets' and 'others' are user arrays of usernames from the original string
    // optionally exclude the the excludeUsername from the "others" array
    export function splitParticipants(participant_str, accounts, excludeUsername) {
        var result = {
            targets: [],
            others: []
        };
        var participants = participant_str.split(",");
        for (i = 0; i < participants.length; i++) {
            var participant = chomp(participants[i], '*');

            if (participants[i].endsWith('*')) {
                if (accounts) {
                    result.targets.push(accounts.findWhere({username: participant}));
                } else {
                    result.targets.push(participant);
                }
            } else if (!excludeUsername || excludeUsername !== participant) {
                if (accounts) {
                    result.others.push(accounts.findWhere({username: participant}));
                } else {
                    result.others.push(participant);
                }
            }
        }
        return result;
    }

    // Takes a conversation object and returns the list of all participants as JSON objects.
    export function accountsFromConversation(conversation) {
        var participants = participantsToList(conversation.participants);
        var accounts = [];

        _.each(participants, function(username) {
            if (_.has(conversation.accounts, username)) {
                accounts.push(conversation.accounts[username]);
            }
        });

        return accounts;
    }

    //simply takes a list of participants and returns as an array, stripping out any targeting information
    export function participantsToList(participantStr) {
        if (participantStr) {
            return participantStr.replace(/\*/g, '').split(',');
        }
        return [];
    }

    export function participantsToTargetList(participantStr) {
        if (participantStr) {
            // find everyone with a star, then strip off the stars
            return _.filter(participantStr.split(','),function(p){
                return p.endsWith("*");
            }).join(",").replace(/\*/g, '').split(',');
        }

        return [];
    }

    // return true if the username is targeted in the participant string or object
    export function isTargeted(participants, username) {
        if (typeof participants === "string") {
            return _.include(participants.split(","), username + "*");
        }
        if (participants.targets) {
            return _.include(participants.targets, username);
        }
        // not really sure - no data was passed in for participants->targets
        return false;
    }

    export function splitTags(tagList) {
        var tagInfo = [];
        var i;
        if (tagList) {
            for (i = 0; i < tagList.length; i++) {
                tagInfo.push({
                    tagName: tagList[i].replace(/[^a-zA-Z0-9]/g, "_").toLowerCase(),
                    tagLabel: tagList[i]
                });
            }
        }
        return tagInfo;
    }

    export function compareConversationProperties(convProps, withConvProps) {
        var simpleProps = _.filter(["subject","aboutuser_id","participants","status"],function(prop){
            return convProps[prop] !== withConvProps[prop];
        });

        var listProps = _.filter(["tags"],function(prop){
            return (convProps[prop] && convProps[prop].join(",")) !== (withConvProps[prop] && withConvProps[prop].join(","));
        });

        return simpleProps.concat(listProps);
    }

    // abbreviate a full name as first name + last initial
    export function abbreviateName(name) {
        var parts = name.split(' ');
        if (parts.length === 1) {
            return name; // only one name, so just return it
        }
        parts[parts.length - 1] = parts[parts.length - 1].substr(0, 1);
        return parts.join(" ") + ".";
    }

    // maintains a cache of known profile photos by username - if we detect a change, we broadcast an event indicating the change
    // Accepted parameters:
    // username, size, refresh, seqnum, id, accountType, asBase64, skipProfileUpdateTrigger
    let _profileImageVersionCache = {};
    export function profileImageSrc(params) {
        var username = params.username;
        var size = params.size || "smthm";
        var seqnum = params.seqnum;
        var id = params.id;
        var accountType = params.accountType;
        var asBase64 = params.asBase64;
        var skipProfileUpdateTrigger = params.skipProfileUpdateTrigger;

        if (accountType === "s") {
            return "/converse/images/team-160.png";
        }

        if (!username || username.length === 0 || !seqnum || seqnum === undefined || seqnum === 0) {
            if (accountType && _.contains(["g","r"], accountType)) {
                return "/converse/images/team-160.png";
            } else {
                return "/converse/images/user-profile-" + size + ".jpg";
            }
        }

        // under some circumstances, we need to load images using AJAX (so we can set auth headers),
        // thus - if we didn't ask for a b64 url, return a blank url since we'll fetch it later
        if (!asBase64 && App?.config?.get("noCookies")) {
            return "";
        }

        var url = "/account/ViewPicture?" +
                    "foruser=" + username +
                    "&org_ids=" + App.account.getAllOrgIds().join(",") +
                    "&size=" + size;

        // we've been told about a particular seqnum
        if (seqnum) {
            if (_profileImageVersionCache[username] && _profileImageVersionCache[username] !== seqnum) {
                //if we've been told about a particular user name, then we can broadcast an update
                if (id && !skipProfileUpdateTrigger) {
                    App.trigger("app:profile_photo_updated", username, seqnum);
                }
            }
            _profileImageVersionCache[username] = seqnum;
        }

        if (_profileImageVersionCache[username]) {
            url += "&seqnum=" + _profileImageVersionCache[username];
        }

        if (asBase64) {
            url += "&photo_as_base64=1";
        }

        return url;
    }

    export function attachThumbSrc(attachment, size, asBase64, extraOptions) {
        // under some circumstances, we need to load images using AJAX (so we can set auth headers),
        // thus - if we didn't ask for a b64 url, return a blank url since we'll fetch it later
        if(!asBase64 && App.config && App.config.get("noCookies"))
        {
            return "";
        }

        if(!_.has(attachment,"hasThumbnail") || attachment.hasThumbnail)
        {
            var url = "/attachment/View?size="+(size||"prf")+"&seqnum="+attachment.seqnum;
            if(asBase64)
            {
                url+= "&photo_as_base64=1";
            }
            return url;
        }
        if(attachment.type === "twistle/form-definition")
        {
            if(extraOptions && extraOptions === "available_form")
            {
                return "/converse/images/file_icons/form.svg";
            }
            return "/converse/images/file_icons/form.svg";
        }
        if(attachment.type === "twistle/form-submission")
        {
            return "/converse/images/responsive/FormSubmission.png";
        }
        if(attachment.type === "twistle/workflow-definition")
        {
            return "/converse/images/responsive/WorkflowDefinition.png";
        }

        return "/converse/images/file_icons/misc.svg";
    }

    // potentially renders images using Ajax
    export function postRenderImages($container, loadedCallback, skipProfileUpdateTrigger, forceImageLoadViaAjax) {
        var loadImageAsB64 = function(url, $imageTag, username, seqnum) {
            var setImageB64Src = function(srcData) {
                try {
                    $imageTag.prop("src","data:image/jpeg;base64," + srcData);
                } catch(e) {
                    // something failed
                    $imageTag.prop("src",url);
                }

                if (loadedCallback) {
                    $imageTag.imagesLoaded(loadedCallback);
                }
            };

            var storageKey = "tws-thumb-" + username + "-" + seqnum;
            var localImageExists;
            try {
                if(window.localStorage && username && seqnum)
                {
                    var imgBlob = window.localStorage.getItem(storageKey);
                    if(imgBlob)
                    {
                        localImageExists = true;
                        // we already have this image, set it now
                        setImageB64Src(imgBlob);
                    }
                }
            } catch (e) {
                localImageExists = false;
            }
            if(!localImageExists)
            {
                ajax.request(url, {}, [], function(resp){

                    try {
                        window.atob(resp); // fails if resp isn't b64
                        setImageB64Src(resp);
                    } catch(e) {
                        // something failed setting the image
                        console.log(e);
                    }

                    try {
                        if(window.localStorage)
                        {
                            window.localStorage.setItem(storageKey, resp);
                        }
                    } catch(e) {
                        // something failed setting local storage
                    }

                }, false, function(err){
                    return true; // prevent any displayed warnings if this image load fails
                }, undefined, true);
            }
        };

        // profile pics
        $container.find(".profile_image:not(.processed,.no_image)").each(function(idx, imageWrapEl) {
            var $imageWrap = $(imageWrapEl);
            $imageWrap.addClass("processed");
            var seqnum = $imageWrap.data("seqnum");
            var username = $imageWrap.data("username");
            var accountType = $imageWrap.data("accounttype");

            if (accountType === "s" && username) {
                // render a HTML-based avatar
                var org = App.account.getOrgByAllMemberAccountUsername(username);
                $imageWrap.html('<span class="org_profile_avatar">'+org.abbreviation+'</span>');
                return;
            }

            // 0 is an invalid seqnum / photo not set
            if (seqnum === 0 || seqnum === "") {
                seqnum = undefined;
                username = undefined;
            }

            var imageParams = {
                username: username||undefined,
                size: "prf",
                seqnum: seqnum,
                id: false,
                accountType: accountType || "",
                skipProfileUpdateTrigger: skipProfileUpdateTrigger
            };

            if (username && !App?.config?.get("isStaticOutput")) {
                // we will attempt to load the image content via AJAX unless we are generating static output
                imageParams.asBase64 = true;
                let url = profileImageSrc(imageParams);
                var $img = null;
                if ($imageWrap.is("img")) {
                    $img = $imageWrap;
                }
                else {
                    $img = $("<img></img>");
                    $imageWrap.html("").append($img);
                }

                loadImageAsB64(url, $img, username, seqnum);
            }
            else {
                let url = profileImageSrc(imageParams);
                if ($imageWrap.is("img")) {
                    $imageWrap.prop("src", url);
                }
                else{
                    $imageWrap.html(`<img src="${url}"/>`);
                }
            }
        });

        // attach thumbs
        $container.find(".attach_thumb:not(.processed,.no_image)").each(function(idx, imageWrapEl){
            var $imageWrap = $(imageWrapEl);
            $imageWrap.addClass("processed");

            var attach = $imageWrap.data();

            var thumbClass;

            if(attach.type === "twistle/form-definition")
            {
                thumbClass = "form-definition";
            }
            if(attach.type === "twistle/form-submission")
            {
                thumbClass = "form-submission";
            }
            if(attach.type === "twistle/workflow-definition")
            {
                thumbClass = "workflow-definition";
            }

            if(thumbClass)
            {
                if(App.config.get("isStaticOutput"))
                {
                    $imageWrap.find("img").hide();
                }
                else
                {
                    $imageWrap.parent().addClass(thumbClass);
                }
                return;
            }

            if(attach.seqnum && App.config && (App.config.get("noCookies") || App.config.get("isStaticOutput")
                || forceImageLoadViaAjax))
            {
                var size = attach.size || "prf";
                if(attach.type.indexOf("image") === 0 && App.config.get("isStaticOutput"))
                {
                    size = "std";
                }
                var url = attachThumbSrc(attach, size, true);
                loadImageAsB64(url, $imageWrap, "twsattach", attach.seqnum);
            }
        });
    }

    export function renderHelpPopover({$container, content, buttonText, width=null, topOverride=null}){
        content = (content || "").replace(/\n/g, '<br/>');

        if(!buttonText || buttonText.length === 0)
        {
            buttonText = Strings.OK;
        }

        let options = {
            content: content,
            confirmText: buttonText
        };

        let $popover = $(renderTemplate(helpPopoverTemplate, options));
        activateLinks($popover, "*", undefined, undefined, undefined, undefined, undefined, App.config.get("country_codes"));
        let newTop = topOverride || $container.parent().height() - 2;
        $popover.css("top", newTop);

        $popover.appendTo($container.parent());

        $popover.find("button.confirm_button").on("click", function(){
            $popover.remove();
        });
        let pos = $container.position();

        if(pos?.left && pos.left < 400){
            $popover.css({left: pos.left - 8, right: "auto"}).addClass("left-hand");
        }

        if(width){
            $popover.css("width", width);
        }

        let animated = false;
        setInterval(function(){
            $popover.css("top", animated ? newTop : newTop + 8);
            animated = !animated;
        }, 600);

        return $popover;
    }

    export function getClientCompletionUrl() {
        if (App.account.isProvider()) {
            // client completion is not for providers
            return null;
        }
        if (isInIFrame()) {
            // we are in an iframe, so no client completion url
            return null;
        }
        return App.account.getDefaultOrg()?.extended_props?.patient_view_completion_url;
    }

    // for calc object size
    export function sizeOf(obj) {
        var size = 0,
            key;
        for (key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                size++;
            }
        }
        return size;
    }

    /**
     * Checks the strength of a password.
     * Returns  on empty input string, -2 on weak password, 0 on medium strength password or 1 on strong password.
     * @param passwordToCheck string
     * @return integer
     * Created By Rashid for Web developer juice
     */
    export function passwordStrength(pwd, securityPolicy) {
        var excellentRegex = new RegExp("^(?=.{9,})(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*\\W).*$", "g");
        var strongRegex = new RegExp("^(?=.{8,})(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*\\W).*$", "g");
        var mediumRegex = new RegExp("^(?=.{7,})(((?=.*[A-Z])(?=.*[a-z]))|((?=.*[A-Z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[0-9]))).*$", "g");
        var enoughRegex = new RegExp("(?=.{6,}).*", "g");

        var resp = {};

        if (excellentRegex.test(pwd)) {
            resp.value = 4;
            resp.message = localize("ChangePasswordScreen-excellent", "Excellent", {comment: "Password quality rank 1. The best.", priority: 1});
        } else if (strongRegex.test(pwd)) {
            resp.value = 3;
            resp.message = localize("ChangePasswordScreen-good","Good", {comment: "Password quality rank 2.", priority: 1});
        } else if (mediumRegex.test(pwd)) {
            resp.value = 2;
            resp.message = localize("ChangePasswordScreen-decent","Decent", {comment: "Password quality rank 3."});
        } else if (enoughRegex.test(pwd)) {
            resp.value = 1;
            resp.message = localize("ChangePasswordScreen-ok","OK", {comment: "Password quality rank 4."});
        } else {
            resp.value = 0;
            resp.message = localize("ChangePasswordScreen-notstrong","Not strong enough", {comment: "Password quality unacceptable."});
        }

        // policy override
        if(securityPolicy)
        {
            if(securityPolicy.required_password_complexity && parseInt(securityPolicy.required_password_complexity,10) > 1)
            {
                var tests = [
                    "[a-z]",
                    "[A-Z]",
                    "[0-9]",
                    "[^A-Za-z0-9]"],
                    complexity = 0;
                    _.each(tests, function(re){
                        complexity += new RegExp(re).test(pwd) ? 1 : 0;
                    });
                if(complexity < parseInt(securityPolicy.required_password_complexity,10)){
                    resp.value = 0;
                    resp.message = localize("ChangePasswordScreen-notstrongchars","Not enough types of characters");
                }
            }
            if(securityPolicy.required_password_length && parseInt(securityPolicy.required_password_length,10) > pwd.length)
            {
                resp.value = 0;
                resp.message = localize("ChangePasswordScreen-notstronglen","Not long enough");
            }
        }

        // add in markup for meter
        resp.message += '<div class="pw_meter_wrap"><div class="pw_meter"></div></div>';

        return resp;
    }

    export function formatNote(noteStr) {
        return noteStr ? escapeHTML(noteStr).replace(/\n/g, '<br/>') : "";
    }

    export function formatPhone(phoneStr) {
        if (phoneStr && phoneStr.length === 10){
            return "(" + phoneStr.substr(0,3) + ") " + phoneStr.substr(3,3) + "-" + phoneStr.substr(6);
        }
        return phoneStr;
    }

    export function cleanPhone(phoneStr) {
        return phoneStr.replace(/[\-\(\)\. ]/g, '')
    }

    export function activateLinks($container, cssFilter, convseq, noteId, fieldId, shortUrls, disableTracking, country_codes) {
        $container.find(cssFilter).each(function(idx, elem) {
            var $elem = $(elem);
            if (!$elem.hasClass("linkified")) {
                let initialHtml = $elem.html();
                let linkedHtml = linkifyHtml(initialHtml, {
                    attributes: (href) => {
                        return {"data-url": href};
                    },
                    formatHref: (href) => {
                        let urlKey = _.unescape(href);
                        if (href && shortUrls && shortUrls[urlKey]) {
                            href = shortUrls[urlKey];
                        }
                        return href;
                    },
                    format: (hrefString) => {
                        let urlKey = _.unescape(hrefString);
                        if (hrefString && shortUrls && shortUrls[urlKey]) {
                            hrefString = shortUrls[urlKey];
                        }
                        if (hrefString && hrefString.length > 85){
                            hrefString = hrefString.substring(0,50) + hrefString.substr(50).replace(/([=&\?\/\-])/gi, "$1 ");
                        }
                        return hrefString;
                    },
                    defaultProtocol: 'https'
                });

                let numLinks = (linkedHtml.match(/<\/a>/g) || []).length;
                let cleanTextList = [];
                let linkList = [];

                // replace links with temporary text
                for (let i = numLinks; i > 0; i--) {
                    let cleanText = "#TwistleURLlink#" + i,
                    link = '<a ' + linkedHtml.split('<a ').pop().split('</a>').shift() + '</a>';

                    // store temporary text and links using the same index so we can put them back later
                    cleanTextList[i - 1] = cleanText;
                    linkList[i - 1] = link;

                    linkedHtml = linkedHtml.replace(link, cleanText);
                }

                // autolink phone numbers
                linkedHtml = replacePhoneNumbers(linkedHtml, convseq, fieldId, false, country_codes);

                // replace temporary text with our original links
                for (let i = 0; i < numLinks; i++) {
                    linkedHtml = linkedHtml.replace(cleanTextList[i], linkList[i]);
                }

                $elem.html(linkedHtml).addClass("linkified");
                $elem.find("a").data({
                    convseq: `${convseq || ""}`,
                    note_id: `${noteId || ""}`,
                    disable_track: `${disableTracking ? "1" : ""}`
                }).on("click", followLink);
            }
        });
    }

    export function replacePhoneNumbers(oldhtml, convseq, fieldId, formatOnly, country_codes) {
        let newhtml = oldhtml.replace(/href=['"]callto:/gi,'href="tel:');
        let phoneList = [];
        for (let country_code of country_codes || ["US"]) {
            phoneList = phoneList.concat(findPhoneNumbersInText(oldhtml, country_code));
        }
        // Sort the phone list because we rely on position later in the function, and numbers may be out of order in cases with > 1 country code
        phoneList.sort((a, b) => a.startsAt - b.startsAt);

        for (let i = 0; i < phoneList.length; i++) {
            let newPhoneHtml = "";
            let phone = phoneList[i].number;
            let formattedNumber = `${phone.countryCallingCode} ${phone.formatNational()}`;

            if (formatOnly) {
                newPhoneHtml = formattedNumber;
            } else {
                newPhoneHtml = "<a class='tws_dial_number' " +
                    "data-url='" + phone.getURI() +
                    "' data-phone='" + phone.number +
                    "' data-convseq='" + (convseq || "") +
                    "' data-field_id='" + (fieldId || "") +
                    "' href='" + phone.getURI() + "'>" + formattedNumber + "</a>";
            }
            let originalLength = phoneList[i].endsAt - phoneList[i].startsAt;
            newhtml = newhtml.substring(0, phoneList[i].startsAt) + newPhoneHtml + newhtml.substring(phoneList[i].endsAt);
            if (phoneList.length > i+1) {
                for (let o = i+1; o < phoneList.length; o++) {
                    phoneList[o].startsAt += (newPhoneHtml.length - originalLength);
                    phoneList[o].endsAt += (newPhoneHtml.length - originalLength);
                }
            }
        }

        return newhtml;
    }

    export function followLink(e) {
        var target = "_blank", $targ = $(e.currentTarget), url = $targ.data("url") || $targ.attr("href");

        // send tracking event to server unless disabled
        if($targ.data("disable_track") != "1") {
            ajax.request("/util/TrackLinkUsage", {
                url: url,
                convseq: $targ.data("convseq"),
                field_id: $targ.data("field_id"),
                note_id: $targ.data("note_id")
            }, [], function () {
            }, false, function () {
            });
        }


        // don't try to open tel urls in new window
        if ($targ.data("phone")) {
            return true;
        }

        window.open(url, target);
        e.stopPropagation();
        e.preventDefault();
        return false;
    }

    export function highlightSearchTerms(text, terms) {
        if(terms && terms.length > 0){
            var regex = new RegExp("(" + terms.join("|") + ")","ig");
            text = text.replace(regex,"<em class='highlighted_search_term'>$1</em>");
        }
        return text;
    }

    export function truncateFilename(filename, maxLength) {
        var localMax = maxLength || 14;

        if(filename.length > localMax){
            var fileparts = filename.split(".");
            filename = filename.substr(0,13) + "...";
            if(fileparts.length > 0){
                filename += fileparts[fileparts.length-1];
            }
        }
        return filename;
    }

    /**
     * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
     * © 2011 Colin Snover <http://zetafleet.com>
     * Released under MIT license.
     */
    ( function(Date) {
        var origParse = Date.parse, numericKeys = [1, 4, 5, 6, 7, 10, 11];
        Date.parse = function(date) {
            var timestamp, struct, minutesOffset = 0;

            // ES5 §15.9.4.2 states that the string should attempt to be parsed as a Date Time String Format string
            // before falling back to any implementation-specific date parsing, so that's what we do, even if native
            // implementations could be faster
            //              1 YYYY                2 MM       3 DD           4 HH    5 mm       6 ss        7 msec        8 Z 9 ±    10 tzHH    11 tzmm
            struct = /^(\d{4}|[+\-]\d{6})(?:-(\d{2})(?:-(\d{2}))?)?(?:T(\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{3}))?)?(?:(Z)|([+\-])(\d{2})(?::(\d{2}))?)?)?$/.exec(date);
            if(struct) {
                // avoid NaN timestamps caused by "undefined" values being passed to Date.UTC
                _.each(numericKeys, function(k){
                    struct[k] = +struct[k] || 0;
                });

                // allow undefined days and months
                struct[2] = (+struct[2] || 1) - 1;
                struct[3] = +struct[3] || 1;

                if(struct[8] !== 'Z' && struct[9] !== undefined) {
                    minutesOffset = struct[10] * 60 + struct[11];
                    var zero = 0;
                    if(struct[9] === '+') {
                        minutesOffset = zero - minutesOffset;
                    }
                }
                timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
            }
            else {
                timestamp = origParse ? origParse(date) : NaN;
            }

            return timestamp;
        };

    }(Date));

    var Utils_Months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var Utils_Days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    /**
     * Parses the provided string and turns it into a date.
     * @param  {string} dateStr
     * @param  {} skipTZAdjust
     */
    export function parseDate(dateStr, skipTZAdjust) {
        var time_string_utc_epoch = Date.parse(dateStr);
        var time_utc = new Date();
        time_utc.setTime(time_string_utc_epoch);
        return time_utc;
    }

    /**
     * Creates formatted datetime strings.
     * FIXME: this should be cleaned up and merged/replaced with dateFormat in date.js
     * @param  {Date} parsedDate The date that will be turned into a formatted string.
     * @param  {string?} formatString Optional date/time format string.
     * @param  {string?} formatType Optional string specifying one of a few default styles.
     */
    export function formatParsedDate(parsedDate, formatString, formatType) {
        var hours = parsedDate.getHours();
        var ampm = "am";
        var month = parsedDate.getMonth() + 1;
        var month_name = Utils_Months[parsedDate.getMonth()];
        var min = parsedDate.getMinutes();
        var dayn = parsedDate.getDay();
        var day = Utils_Days[dayn];
        var date = parsedDate.getDate();
        var year = parsedDate.getFullYear();
        var fhours = betterFormatDate(parsedDate, "HH");

        if (hours >= 12) {
            ampm = "pm";
            hours -= 12;
        }

        if (hours === 0) {
            hours = 12;
        }

        if (min < 10) {
            min = '0' + min;
        }

        if (!formatString) {
            switch(formatType)
            {
                case "DEFAULT_24":
                    year = year % 100;
                    formatString = "{month}/{date}/{year} {fhours}:{min}";
                    break;
                case "NO_YEAR_24":
                    formatString = "{month}/{date} {fhours}:{min}";
                    break;
                case "DEFAULT_WITH_YEAR":
                    formatString = "{year} {month_name} {date} {hour}:{min} {ampm}";
                    break;
                default:
                    formatString = "{month_name} {date} {hour}:{min} {ampm}";
            }
        }

        return Mustache.render(formatString, {
            month: month,
            month_name: month_name,
            date: date,
            day: day,
            hour: hours,
            min: min,
            ampm: ampm,
            year: year,
            fhours: fhours,
            dayn: dayn
        }, null, ['{', '}']);
    }

    export function formatConversationListItemDate(date) {
        var dateFormat = isToday(date) ? "shortTime" : "shortDate";
        return betterFormatDate(date, dateFormat);
    }

    export function formatDate(dateStr, formatString, formatType) {
        return formatParsedDate(parseDate(dateStr), formatString, formatType);
    }

    // Turns 17:00 into 5:00 PM
    export function formatTime(timeStr) {
        var time_string = String(timeStr);
        var time_hours = Number(time_string[0] + time_string[1]);
        var time_minutes = time_string[3] + time_string[4];
        var am_pm = "AM";

        if (time_hours === 0) {
            time_hours = 12;
        }
        else if(time_hours === 12)
        {
            am_pm = "PM";
        }
        else if(time_hours >= 13) {
            time_hours = time_hours - 12;
            am_pm = "PM";
        }

        return String(time_hours + ":" + time_minutes + " " + am_pm);
    }

    export function dateDiffInMinutes(d1, d2) {
        var t2 = d2.getTime();
        var t1 = d1.getTime();

        return parseInt((t2 - t1) / (60 * 1000), 10);
    }

    export function dateDiffAsAge(today, d2) {
        var age = today.getFullYear() - d2.getFullYear();
        var m = today.getMonth() - d2.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < d2.getDate())) {
            age--;
        }
        return age;
    }

    export function humanSeconds(seconds, zero_unit) {
        var units = zero_unit || "second";
        var originalValue = seconds || 0
        originalValue = parseInt(originalValue,10);
        var resultValue;

        if(originalValue < 60 || originalValue % 60 !== 0)
        {
            // do nothing, seconds is default
            resultValue = originalValue;
        }
        else if(originalValue < 3600 || originalValue % 3600 !== 0)
        {
            // minutes
            resultValue = Math.ceil(originalValue / 60);
            units = "minute";
        }
        else if(originalValue < 86400 || originalValue % 86400 !== 0)
        {
            // hours
            resultValue = Math.ceil(originalValue / 3600);
            units = "hour";
        }
        else if(originalValue < 604800 || originalValue % 604800 !== 0)
        {
            // days
            resultValue = Math.ceil(originalValue / 86400);
            units = "day";
        }
        else
        {
            // weeks
            resultValue = Math.ceil(originalValue / 604800);
            units = "week";
        }

        return {
            displayUnits:units + (resultValue !== 1 ? "s":""),
            units:units + "s",
            value:resultValue};
    }

    export function humanTimeToSeconds(value, units) {
        if(!value)
        {
            value = 0;
        }

        switch (units)
        {
            case "minutes":
                return value * 60;
            case "hours":
                return value * 3600;
            case "days":
                return value * 86400;
            case "weeks":
                return value * 604800;
            case "seconds":
                // multiply by 1 to coerce to a number (treat seconds like other types)
                return value * 1;
            default:
                // shouldn't get here ideally but I'm afraid to make it throw an error.
                return value;
        }
    }

    export function convertInputToDateTime($datePicker, $timePicker) {
        var dateObject = $datePicker.tws_datePicker("getDate");
        if($timePicker.val())
        {
            dateObject = $timePicker.timepicker("getTime", dateObject);
        }
        if(dateObject)
        {
            return betterFormatDate(dateObject, "isoUtcDateTimeNoTZ");
        }
    }

    // linted cleanup of http://stackoverflow.com/questions/6644654/parse-url-with-jquery-javascript
    export function getQuerystringParam(key, default_) {
        var i, pairs;
        if (default_===null)
        {
            default_="";
        }
        var search = decodeURIComponent(window.location.search);
        if (search === "")
        {
            return default_;
        }
        search = search.substr(1);
        var params = search.split("&");
        for (i = 0; i < params.length; i++)
        {
            pairs = params[i].split("=");
            if(pairs[0] === key)
            {
                return pairs[1];
            }
        }

        return default_;
    }

    export function areCookiesEnabled() {
        var cookieEnabled = (navigator.cookieEnabled) ? true : false;

        if (navigator.cookieEnabled === undefined && !cookieEnabled)
        {
            document.cookie="tw_testcookie";
            cookieEnabled = (document.cookie.indexOf("tw_testcookie") !== -1) ? true : false;
        }
        return cookieEnabled;
    }

    export let MobileDevice = {
        getUserAgent:function()
        {
            return (navigator && navigator.userAgent) || "";
        },
        Android: function() {
            return MobileDevice.getUserAgent().match(/Android/i);
        },
        BlackBerry: function() {
            return MobileDevice.getUserAgent().match(/BlackBerry/i);
        },
        iOS: function() {
            return MobileDevice.getUserAgent().match(/iPhone|iPad|iPod/i);
        },
        iPhone: function() {
            return MobileDevice.getUserAgent().match(/iPhone|iPod/i);
        },
        iPad: function() {
            return MobileDevice.getUserAgent().match(/iPad/i);
        },
        Opera: function() {
            return MobileDevice.getUserAgent().match(/Opera Mini/i);
        },
        Windows: function() {
            return MobileDevice.getUserAgent().match(/IEMobile/i) || MobileDevice.getUserAgent().match(/WPDesktop/i);
        },
        Windows8: function() {
            return MobileDevice.getUserAgent().match(/Windows Phone 8/i);
        },
        any: function() {
            return (MobileDevice.Android() || MobileDevice.BlackBerry() || MobileDevice.iOS() || MobileDevice.Opera() || MobileDevice.Windows());
        }
    }

    export function isRenderableVideoType(contentType) {
        return _.contains(["video/m4v","video/mp4","twistle/rdx-video-upload"], contentType);
    }

    export function guidish() {
        // somewhat guid-like function for generating v4 guids
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
            return v.toString(16);
        });
    }

    // https://jsfiddle.net/11szrbx9/
    export function printf(format) {
        var values = Array.prototype.slice.call(arguments, 1);
        function insert(str, val) { return str.replace(/%s/, val); }
        return values.reduce(insert, format);
    }


    //http://stackoverflow.com/a/2631198
    export function getPropertyAtPath(obj /*, level1, level2, ... levelN*/) {
        var args = Array.prototype.slice.call(arguments, 1);

        for (var i = 0; i < args.length; i++)
        {
            if (!obj || !Object.prototype.hasOwnProperty.call(obj, args[i]))
            {
                return false;
            }
            obj = obj[args[i]];
        }
        return obj;
    }

    export function isInIFrame() {
        return window.parent && window.parent.location != window.location;
    }

    export function guessMimeType(fileName) {
        var fileparts = (fileName && fileName.split(".")) || [];
        if (fileparts.length > 0) {
            var ext = fileparts[fileparts.length - 1];

            var types = {
                "323" : "text/h323",
                "*" : "application/octet-stream",
                "acx" : "application/internet-property-stream",
                "ai" : "application/postscript",
                "aif" : "audio/x-aiff",
                "aifc" : "audio/x-aiff",
                "aiff" : "audio/x-aiff",
                "asf" : "video/x-ms-asf",
                "asr" : "video/x-ms-asf",
                "asx" : "video/x-ms-asf",
                "au" : "audio/basic",
                "avi" : "video/x-msvideo",
                "axs" : "application/olescript",
                "bas" : "text/plain",
                "bcpio" : "application/x-bcpio",
                "bin" : "application/octet-stream",
                "bmp" : "image/bmp",
                "c" : "text/plain",
                "cat" : "application/vnd.ms-pkiseccat",
                "cdf" : "application/x-cdf",
                "cer" : "application/x-x509-ca-cert",
                "class" : "application/octet-stream",
                "clp" : "application/x-msclip",
                "cmx" : "image/x-cmx",
                "cod" : "image/cis-cod",
                "cpio" : "application/x-cpio",
                "crd" : "application/x-mscardfile",
                "crl" : "application/pkix-crl",
                "crt" : "application/x-x509-ca-cert",
                "csh" : "application/x-csh",
                "css" : "text/css",
                "dcr" : "application/x-director",
                "der" : "application/x-x509-ca-cert",
                "dir" : "application/x-director",
                "dll" : "application/x-msdownload",
                "dms" : "application/octet-stream",
                "doc" : "application/msword",
                "dot" : "application/msword",
                "dvi" : "application/x-dvi",
                "dxr" : "application/x-director",
                "eps" : "application/postscript",
                "etx" : "text/x-setext",
                "evy" : "application/envoy",
                "exe" : "application/octet-stream",
                "fif" : "application/fractals",
                "flr" : "x-world/x-vrml",
                "gif" : "image/gif",
                "gtar" : "application/x-gtar",
                "gz" : "application/x-gzip",
                "h" : "text/plain",
                "hdf" : "application/x-hdf",
                "hlp" : "application/winhlp",
                "hqx" : "application/mac-binhex40",
                "hta" : "application/hta",
                "htc" : "text/x-component",
                "htm" : "text/html",
                "html" : "text/html",
                "htt" : "text/webviewhtml",
                "ico" : "image/x-icon",
                "ief" : "image/ief",
                "iii" : "application/x-iphone",
                "ins" : "application/x-internet-signup",
                "isp" : "application/x-internet-signup",
                "jfif" : "image/pipeg",
                "jpe" : "image/jpeg",
                "jpeg" : "image/jpeg",
                "jpg" : "image/jpeg",
                "js" : "application/x-javascript",
                "latex" : "application/x-latex",
                "lha" : "application/octet-stream",
                "lsf" : "video/x-la-asf",
                "lsx" : "video/x-la-asf",
                "lzh" : "application/octet-stream",
                "m13" : "application/x-msmediaview",
                "m14" : "application/x-msmediaview",
                "m3u" : "audio/x-mpegurl",
                "m4v" : "video/mpeg",
                "man" : "application/x-troff-man",
                "mdb" : "application/x-msaccess",
                "me" : "application/x-troff-me",
                "mht" : "message/rfc822",
                "mhtml" : "message/rfc822",
                "mid" : "audio/mid",
                "mny" : "application/x-msmoney",
                "mov" : "video/quicktime",
                "movie" : "video/x-sgi-movie",
                "mp2" : "video/mpeg",
                "mp3" : "audio/mpeg",
                "mp4" : "video/mpeg",
                "mpa" : "video/mpeg",
                "mpe" : "video/mpeg",
                "mpeg" : "video/mpeg",
                "mpg" : "video/mpeg",
                "mpp" : "application/vnd.ms-project",
                "mpv2" : "video/mpeg",
                "ms" : "application/x-troff-ms",
                "msg" : "application/vnd.ms-outlook",
                "mvb" : "application/x-msmediaview",
                "nc" : "application/x-netcdf",
                "nws" : "message/rfc822",
                "oda" : "application/oda",
                "p10" : "application/pkcs10",
                "p12" : "application/x-pkcs12",
                "p7b" : "application/x-pkcs7-certificates",
                "p7c" : "application/x-pkcs7-mime",
                "p7m" : "application/x-pkcs7-mime",
                "p7r" : "application/x-pkcs7-certreqresp",
                "p7s" : "application/x-pkcs7-signature",
                "pbm" : "image/x-portable-bitmap",
                "pdf" : "application/pdf",
                "pfx" : "application/x-pkcs12",
                "pgm" : "image/x-portable-graymap",
                "pko" : "application/ynd.ms-pkipko",
                "pma" : "application/x-perfmon",
                "pmc" : "application/x-perfmon",
                "pml" : "application/x-perfmon",
                "pmr" : "application/x-perfmon",
                "pmw" : "application/x-perfmon",
                "png" : "image/png",
                "pnm" : "image/x-portable-anymap",
                "pot" : "application/vnd.ms-powerpoint",
                "ppm" : "image/x-portable-pixmap",
                "pps" : "application/vnd.ms-powerpoint",
                "ppt" : "application/vnd.ms-powerpoint",
                "prf" : "application/pics-rules",
                "ps" : "application/postscript",
                "pub" : "application/x-mspublisher",
                "qt" : "video/quicktime",
                "ra" : "audio/x-pn-realaudio",
                "ram" : "audio/x-pn-realaudio",
                "ras" : "image/x-cmu-raster",
                "rgb" : "image/x-rgb",
                "rmi" : "audio/mid",
                "roff" : "application/x-troff",
                "rtf" : "application/rtf",
                "rtx" : "text/richtext",
                "scd" : "application/x-msschedule",
                "sct" : "text/scriptlet",
                "setpay" : "application/set-payment-initiation",
                "setreg" : "application/set-registration-initiation",
                "sh" : "application/x-sh",
                "shar" : "application/x-shar",
                "sit" : "application/x-stuffit",
                "snd" : "audio/basic",
                "spc" : "application/x-pkcs7-certificates",
                "spl" : "application/futuresplash",
                "src" : "application/x-wais-source",
                "sst" : "application/vnd.ms-pkicertstore",
                "stl" : "application/vnd.ms-pkistl",
                "stm" : "text/html",
                "sv4cpio" : "application/x-sv4cpio",
                "sv4crc" : "application/x-sv4crc",
                "svg" : "image/svg+xml",
                "swf" : "application/x-shockwave-flash",
                "t" : "application/x-troff",
                "tar" : "application/x-tar",
                "tcl" : "application/x-tcl",
                "tex" : "application/x-tex",
                "texi" : "application/x-texinfo",
                "texinfo" : "application/x-texinfo",
                "tgz" : "application/x-compressed",
                "tif" : "image/tiff",
                "tiff" : "image/tiff",
                "tr" : "application/x-troff",
                "trm" : "application/x-msterminal",
                "tsv" : "text/tab-separated-values",
                "txt" : "text/plain",
                "uls" : "text/iuls",
                "ustar" : "application/x-ustar",
                "vcf" : "text/x-vcard",
                "vrml" : "x-world/x-vrml",
                "wav" : "audio/x-wav",
                "wcm" : "application/vnd.ms-works",
                "wdb" : "application/vnd.ms-works",
                "wks" : "application/vnd.ms-works",
                "wmf" : "application/x-msmetafile",
                "wps" : "application/vnd.ms-works",
                "wri" : "application/x-mswrite",
                "wrl" : "x-world/x-vrml",
                "wrz" : "x-world/x-vrml",
                "xaf" : "x-world/x-vrml",
                "xbm" : "image/x-xbitmap",
                "xla" : "application/vnd.ms-excel",
                "xlc" : "application/vnd.ms-excel",
                "xlm" : "application/vnd.ms-excel",
                "xls" : "application/vnd.ms-excel",
                "xlt" : "application/vnd.ms-excel",
                "xlw" : "application/vnd.ms-excel",
                "xof" : "x-world/x-vrml",
                "xpm" : "image/x-xpixmap",
                "xwd" : "image/x-xwindowdump",
                "z" : "application/x-compress",
                "zip" : "application/zip"
            };
            return types[ext] || "";
        }
        return "";
    }

    export function getFileIconHtml({fileType=null, hasThumbnail=false, attachment=null}) {
        let icon = "";
        if (hasThumbnail && attachment) {
            let url = attachThumbSrc(attachment, "prf", null, null);
            icon = `<img src='${url}' width='20' />`
        } else {
            const iconPath = fileTypeToIconPath(fileType);
            icon = `<img src='${iconPath}' width='20' alt='' />`;
        }
        return icon;
    }

    export function wrapDialogInAsyncAction(dialogTitle, initialContent, onCreateCallback) {
        var closed = false;
        var $d = $("<div></div>").appendTo($("body"));

        $(".ui-dialog-content").dialog("close");
        $d.html('<div>'+ initialContent + '</div>');
        $d.dialog({
            title:dialogTitle,
            beforeClose: function() {
                closed = true;
            }
        });
        $d.dialog("open");

        function customSetTimeout(fn, interval) {
            if (!closed) {
                return setTimeout(fn, interval);
            }
            return null;
        }

        onCreateCallback($d, customSetTimeout);
    }

    export function asyncExportPollingAttachmentDialog(url, params, dialogTitle, initialContent, pollingContent, expectedType) {
        // calls the supplied URL, expecting `seqnum` in its response, then starts polling for that attachment until
        // it matches the expected type

        wrapDialogInAsyncAction(dialogTitle || "Export", initialContent || "Beginning Export...", function($d, dialogSetTimeout){
            $d.spin();

            ajax.request(url, params, [], function(result){
                var attachSeqnum = result.seqnum;
                $d.text(pollingContent || "Export in progress...").spin();

                function getInfo() {
                    ajax.request(
                        "/attachment/Info",
                        {seqnum: attachSeqnum},
                        [],
                        function success(result){
                            if(result.type===expectedType) {
                                $d.html("");
                                $d.append('<a href="/attachment/View?seqnum='+attachSeqnum+'">Click To Download</a>');
                            } else {
                                let attribs = JSON.parse(result.extended_attributes || "{}");
                                if (attribs.export_status === "failed") {
                                    $d.text(`Export failed: ${attribs.export_failure_reason}. \nPlease contact support.`);
                                } else {
                                    $d.text("Still exporting...").spin();
                                    dialogSetTimeout(getInfo, 3000);
                                }
                            }
                        },
                        false,
                        function fail(e) {
                            dialogSetTimeout(getInfo, 3000);
                        }
                    );
                }
                dialogSetTimeout(getInfo, 3000);
            });
        });
    }

    export function asyncImportPollingAttachmentDialog(attachment, dialogTitle, initialContent, pollingContent, completeCallback) {
        wrapDialogInAsyncAction("Workflow Import", initialContent,
        function($d, dialogSetTimeout){
            $d.spin();
            $d.text("Starting import...").spin();

            function getInfo(){
                ajax.request(
                    "/attachment/Info",
                    {seqnum: attachment.seqnum},
                    [],
                    function success(result) {
                        var attribs = JSON.parse(result.extended_attributes);
                        if(attribs.import_status === "complete")
                        {
                            $d.dialog("close");
                            if(completeCallback){
                                completeCallback(attribs);
                            }
                        } else if (attribs.import_status === "failed") {
                            $d.text(`Import failed: ${attribs.import_failure_reason}. \nPlease contact support.`);
                        } else {
                            $d.text(`${pollingContent} ${attribs.import_status_progress}% complete.`).spin();
                            dialogSetTimeout(getInfo, 3000);
                        }
                    },
                    false,
                    function fail() {
                        dialogSetTimeout(getInfo, 3000);
                    }
                );
            }

            dialogSetTimeout(getInfo, 3000);
        }
    );



    }

    // Lightweight call into server, intended to keep the session alive or
    // provide a meaningless request to attach clickstream data to, etc.
    export function serverKeepAlivePing() {
        let params = { "accountname" : App.account.get("username") };
        ajax.request("/account/Check", params, null, null, false, function() {
            // Return true here to suppress Growl notification if there's an error
            return true;
        });
    }

    // initializes a multi-select dropdown with icons as options
    // classCallback to define the custom class with the value of the option
    export function initMultiSelectIconDropdown({$select, classCallback, defaultVal, showText, noIcons, additionalOptions, containerCssClass, showLabelForSelection, resultCssClass}) {
        const SingleSelection = $.fn.select2.amd.require("select2/selection/single");
        const Placeholder = $.fn.select2.amd.require("select2/selection/placeholder");
        const Dropdown = $.fn.select2.amd.require("select2/dropdown");
        const AttachBody = $.fn.select2.amd.require("select2/dropdown/attachBody");
        const EventRelay = $.fn.select2.amd.require("select2/selection/eventRelay");
        const Utils = $.fn.select2.amd.require("select2/utils");

        let SelectionAdapter = Utils.Decorate(SingleSelection, Placeholder);
        SelectionAdapter = Utils.Decorate(SelectionAdapter, EventRelay);
        let DropdownAdapter = Utils.Decorate(Dropdown, AttachBody);

        let opts = { ...{
            allowClear: false,
            multiple: true,
            placeholder: "",
            selectionAdapter: SelectionAdapter,
            dropdownAdapter: DropdownAdapter,
            templateResult: function (data, container) {
                if (data.id === "clear-all" || data.id === "clear-all-select-all") {
                    $(container).addClass("clear-all-wrap");
                    let $clearWrap = $("<div></div>").addClass("clear-all"),
                        noneSelected = !$select.val().length,
                        allSelected = $select.val().length === $select.find("option").not(".clear-all").length, // -1 because of the "clear all option"
                        $clearButton = $(`<button class="tws-link-button clear-all-button ${noneSelected ? "disabled" : ""}">${data.text}</button>`).appendTo($clearWrap);
                    $clearButton.on("click", function(){
                        $select.val(null).trigger("change").select2("close");
                    });
                    if(data.id === "clear-all-select-all"){
                        let $selectAllButton = $(`<button class="tws-link-button select-all-button ${allSelected ? "disabled" : ""}">Select All</button>`).appendTo($clearWrap);
                        $selectAllButton.on("click", function(){
                            $select.find("option").not(".clear-all").prop("selected", true);
                            $select.trigger("change").select2("close");
                        });
                    }
                    return $clearWrap;
                }
                let custom = $(data.element).data("custom");
                return styleContent($("<div></div>", {
                    class: `${classCallback ? classCallback(data.id) : ""} ${noIcons ? "no_icons" : ""}`,
                    ["data-value"]: data.id,
                    ["data-style"]: custom ? `background-image: url(${custom})` : ""
                }).text(showText ? data.text : "").wrap($("<div></div>", {class: "multi-wrap"})).parent());
            },
            templateSelection: function () {
                if (classCallback) {
                    return $select.val().map(key => {
                        let custom = $select.find(`option[value=${key}]`).data("custom");
                        return styleContent($("<div></div>", {
                            class: classCallback ? classCallback(key) : "",
                            ["data-value"]: key,
                            ["data-style"]: custom ? `background-image: url(${custom})` : ""
                        }));
                    });
                } else if (showLabelForSelection) {
                    const $selections = $select.find(':selected');
                    let selections = [];
                    _.each($selections, selection => {
                        selections.push(selection.text);
                    })

                    if (selections.length == 1) return selections[0];
                    return selections.map(selection => {
                        if (_.last(selections) == selection) {
                            return selection;
                        } else {
                            return `${selection}, `;
                        }
                    });
                } else {
                    if ($select.val().length == 1) return $select.val()[0];
                    return $select.val().map(key => {
                        return key + ', ';
                    });
                }
            }
        }, ...(additionalOptions || {})};

        if (defaultVal) {
            $select.val(defaultVal.split(","));
        }

        $select.select2(opts);

        $select.on("select2:select select2:unselect", function() {
            let clearAllButton = $select.data("select2").$dropdown.find(".clear-all button.clear-all-button");
            clearAllButton?.toggleClass("disabled", !$select.val().length);
            let selectAllButton = $select.data("select2").$dropdown.find(".clear-all button.select-all-button");
            selectAllButton?.toggleClass("disabled", $select.val().length < $select.find("option").not(".clear-all").length);
        });
        if (containerCssClass) {
            $select.data('select2')?.$container.addClass(containerCssClass);
        }
        if (resultCssClass) {
            $select.data('select2')?.$results.addClass(resultCssClass);
        }
    }

    export function initSingleSelectDropdown({$select, classCallback, defaultVal, enableSearchDropdown,
        limitHeight=true, width=0, placeholder=undefined,
                                                 containerCssClass="", resultCssClass="",
                                                 dropdownCssClass="",
                                                 selectOnCloseSearchDropdown= true,
                                                 additionalOptions = {}}) {
        let selectOnClose = false;
        let minimumResultsForSearch = -1;

        if (enableSearchDropdown) {
            minimumResultsForSearch = 1;
            selectOnClose = selectOnCloseSearchDropdown;

            $select.on('select2:open', () => {
                let $dropdown = $select.data('select2').$dropdown,
                    searchField = $dropdown.find(".select2-search__field");

                if (searchField.length) {
                    searchField[0].focus();
                }
            });
        }
        if(dropdownCssClass){
            $select.on('select2:open', () => {
                let $dropdown = $select.data('select2').$dropdown;
                $dropdown.addClass(dropdownCssClass);
            });
        }

        let config = {... {
            allowClear: false,
            dropdownAutoWidth : true,
            placeholder: placeholder,
            minimumResultsForSearch: minimumResultsForSearch,
            selectOnClose: selectOnClose,
            templateResult: function (data) {
                let custom = $(data.element).data("custom");
                return styleContent($(`<div></div>`, {
                    class: `${classCallback ? classCallback(data.id) : ""} single-text`,
                    ["data-value"]: data.id,
                    text: custom ? "" : data.text,
                    ["data-style"]: custom ? `background-image: url(${custom})` : "",
                }).wrap($("<div></div>", {
                    class: 'single-wrap',
                })).parent());
            },
            templateSelection: function (data) {
                // This is a bit confusing, but if there is a classCallback that means we are
                // rendering images, so return the right background-image stuff. If not, we
                // are rendering plain text, so just return it
                if (classCallback) {
                    let custom = data.id ? $select.find(`option[value=${data.id}]`).data("custom") : "";
                    return styleContent($("<div></div>", {
                        class: `${classCallback ? classCallback(data.id) : ""} single-text`,
                        ["data-value"]: data.id,
                        text: custom ? "" : data.text,
                        ["data-style"]: custom ? `background-image: url(${custom})` : ""
                    }));
                }
                return data.text;
            },
        }, ...(additionalOptions || {})};

        if (width) {
            config.width = width;
        }

        if (defaultVal) {
            $select.val(defaultVal);
        }

        $select.select2(config);

        if (!limitHeight) {
            $select.data('select2')?.$results.css('max-height', 'none');
            $select.data('select2')?.$selection.css('height', 'auto');
            $select.data('select2')?.$selection.children().css('white-space', 'normal');
        }

        if (containerCssClass) {
            $select.data('select2')?.$container.addClass(containerCssClass);
        }

        if (resultCssClass) {
            $select.data('select2')?.$results.addClass(resultCssClass);
        }
    }

    export function checkBackgroundClick(evt, nonBackgroundList, callback) {
        let onBackground = true;
        let currentTarget = evt.target;
        while (null != currentTarget && currentTarget.id != "main_container") {
            if (nonBackgroundList.includes(currentTarget.className)) {
                onBackground = false;
            }
            currentTarget = currentTarget.parentElement;
        }
        if (onBackground) {
            callback();
        }
    }

    export function canChangeTwistleTab(me, tabName, subDialog) {
        if (me.currentTab !== tabName) {
            return true;
        }

        let fieldEditDialog = me._subDialogs?.[subDialog]
        if (!fieldEditDialog) {
            return true;
        }

        let hasChanges = fieldEditDialog.hasChanges();
        if (!hasChanges) {
            return true;
        }

        let shouldClose = fieldEditDialog.shouldCloseView();
        if (shouldClose) {
            fieldEditDialog.resetHasChanges();
            return true;
        }

        return false;
    }
